import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const ManageChannelsInfoContainer = styled.div<React.CSSProperties>`
  left: ${700 * Screen.widthRatio}px;
  position: fixed;
  top: ${362 * Screen.widthRatio}px;
  width: ${1000 * Screen.widthRatio}px;
`;

export default ManageChannelsInfoContainer;
